module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _c('a', {
    attrs: {
      "id": "p2"
    }
  }), _c('a', {
    attrs: {
      "id": "p3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 2021 by Adam Stern, MD")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Names: Stern, Adam (Psychiatrist), author.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Title: Committed : dispatches from a psychiatrist in training / Adam Stern.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Description: Boston : Houghton Mifflin Harcourt, 2021.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Identifiers: LCCN 2020057716 (print) | LCCN 2020057717 (ebook) | ISBN 9780358434733 (hardcover) | ISBN 9780358450351 | ISBN 9780358450511 | ISBN 9780358435488 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Subjects: LCSH: Stern, Adam (Psychiatrist) | Harvard Medical School. | Psychiatrists—United States—Biography. | Residents (Medicine)—United States—Biography. | Psychiatry—Study and teaching (Residency)—United States.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Classification: LCC RC438.6.S75 A3 2021 (print) | LCC RC438.6.S75 (ebook) | DDC 616.89092 [B]—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2020057716",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2020057716")])]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("LC ebook record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2020057717",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2020057717")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Cover design by Lynn Buckley")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Cover photograph © Roman Sigaev / Shutterstock")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Author photograph © Kate McKenna / Crabapple Photography")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("v1.0621")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Version 04222022KO")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d48f4458","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0